import { useState } from "react";

import type { SowingInstruction } from "../services/sowingInstructionsApi";
import { SowingInstructionsTable } from "../components/sowingInstructions/SowingInstructionsTable";
import { RecordSowingDialog } from "../components/sowingInstructions/RecordSowingDialog";

const SOWING_INSTRUCTION_STATUSES = [
  { value: 0, label: "Pending" },
  { value: 1, label: "Issued" },
  { value: 2, label: "Sown" },
  { value: 3, label: "Germinated" },
  { value: 4, label: "Growing" },
  { value: 5, label: "Ready for Dispatch" },
  { value: 6, label: "Stored" },
  { value: 7, label: "Dispatched" },
  { value: 8, label: "Overgrown" },
  { value: 9, label: "Revoked" },
  { value: 10, label: "On Hold" },
  { value: 11, label: "Ready for Growing" },
  { value: 12, label: "Draft" },
  { value: 13, label: "Partially Sown" },
];

export const RecordSowingPage = () => {
  const [selectedInstruction, setSelectedInstruction] =
    useState<SowingInstruction | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleUpdateStatus = (instruction: SowingInstruction) => {
    setSelectedInstruction(instruction);
    setDialogOpen(true);
  };

  const handleDialogSuccess = () => {
    setDialogOpen(false);
    setSelectedInstruction(null);
    // RecordSowing mutation invalidates ["sowingInstructions"], so the table's
    // paged query refetches automatically.
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Record Sowing</h1>
        <p className="text-gray-500 mt-1">
          Record actual sowing details for issued instructions
        </p>
      </div>

      <SowingInstructionsTable
        serverPagedStatuses={[1, 13]}
        serverPagedIncludeUnfinishedSowing
        statuses={SOWING_INSTRUCTION_STATUSES}
        onUpdateStatus={handleUpdateStatus}
        updateStatusLabel="Record Sowing"
      />

      {selectedInstruction && (
        <RecordSowingDialog
          instruction={selectedInstruction}
          open={dialogOpen}
          onOpenChange={setDialogOpen}
          onSuccess={handleDialogSuccess}
        />
      )}
    </div>
  );
};